@if(!item.navCap && !item.external && !item.twoLines) {
<a
  mat-list-item
  (click)="onItemSelected(item)"
  [ngClass]="{
    'activeMenu': item.route ? router.isActive(item.route, true) : false,
    'expanded': expanded,
    'disabled': item.disabled,
    'is-child': depth > 0
  }"
  class="menu-list-item {{ item.bgcolor }}"
  [style.--indent-level]="depth"
>
  <div class="item-content">
    <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
    <span class="hide-menu" [matTooltip]="item.displayName?.length > 20 ? (item.displayName | translate) : ''">
      {{ item.displayName | translate }}
    </span>
  </div>
  
  @if(item.children && item.children.length) {
  <span class="arrow-icon">
    <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'" style="font-size: 20px; width: 20px; height: 20px;">
      expand_more
    </mat-icon>
  </span>
  } 
  
  @if(item.chip){
  <span>
    <span class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill ">
      {{ item.chipContent }}
    </span>
  </span>
  }
</a>
}

@if(item.children && item.children.length && expanded) {
<div class="sub-menu">
  @for(child of item.children; track child) {
  <app-nav-item 
    [item]="child" 
    (notify)="notify.emit($event)" 
    [depth]="depth + 1">
  </app-nav-item>
  }
</div>
}

@if(!item.navCap && item.external) {
<mat-list-item
  (click)="onItemSelected(item)"
  class="menu-list-item {{ item.bgcolor }}"
  target="_blank"
>
  <div class="item-content">
    <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
    <span class="hide-menu">{{ item.displayName | translate }}</span>
  </div>
</mat-list-item>
}